import { Button, CircularProgress, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DownloadIcon from '@mui/icons-material/Download';
import { useTheme } from '@mui/system';
import { NAVIGATION_NS } from '../../i18n/navigation';
import { useCallback } from 'react';

interface ExportButtonProps {
  onHandleExportData: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const ExportButton = ({ onHandleExportData, isLoading, disabled }: ExportButtonProps) => {
  const { t } = useTranslation([NAVIGATION_NS]);
  const { palette, breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down(700));

  const handleExportData = useCallback(
    (event: React.SyntheticEvent) => {
      event.stopPropagation();
      onHandleExportData();
    },
    [onHandleExportData],
  );

  return (
    <Button
      sx={{
        ml: '16px',
        borderColor: palette.secondary.border,
        bgColor: palette.secondary.main,
        color: palette.text.primary,
        maxHeight: '36px',
        minWidth: isMobile ? '20px' : '72px',
        marginLeft: isMobile ? 0 : '8px',
        '> span': {
          marginRight: isMobile ? 0 : '8px',
        },
      }}
      variant="outlined"
      color="secondary"
      startIcon={isLoading ? <CircularProgress size={20} /> : <DownloadIcon />}
      onClick={handleExportData}
      disabled={disabled}
    >
      {isMobile ? null : (
        <Typography sx={{ 'white-space': 'nowrap' }}>{t('navigation:export')}</Typography>
      )}
    </Button>
  );
};
